export const EXCEL_ERROR_TITLE = 'Скачать Excel';
export const EXCEL_ERROR_MESSAGE = 'Не удалось сформировать файл выгрузки';
